// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-panel {\n  height: 70%;\n  max-height: 70%;\n}[dir] .nav-panel {\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #e0e0e0;\n}\n.selected-docs-panel {\n  height: 30%;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
